import { Controller } from '@hotwired/stimulus';
import Lenis from 'lenis';

export default class extends Controller {
	static targets = ['section'];

	connect() {
		try {
			this.initLenis();
			if (this.hasSectionTarget) {
				this.setupParallax();
			} else if (process.env.NODE_ENV === 'development') {
				console.warn('SmoothScroll: No parallax sections found - running in smooth-scroll-only mode');
			}
		} catch (error) {
			console.error('SmoothScroll initialization failed:', error);
		}
	}

	initLenis() {
		this.lenis = new Lenis({
			lerp: 0.08,
			wheelMultiplier: 1.1,
			smoothTouch: false,
		});

		const raf = (time) => {
			this.lenis.raf(time);
			requestAnimationFrame(raf);
		};
		requestAnimationFrame(raf);
	}

	setupParallax() {
		this.sectionTargets.forEach((section) => {
			const speed = parseFloat(section.dataset.speed) || 0.1;
			const offset = parseFloat(section.dataset.offset) || 0;
			section.style.willChange = 'transform';
			const originalPosition = section.getBoundingClientRect().top + window.scrollY;

			this.lenis.on('scroll', ({ scroll }) => {
				const translateY = (scroll - originalPosition) * speed + offset;

				const rect = section.getBoundingClientRect();
				const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

				if (isInViewport) {
					section.style.transform = `translateY(${translateY}px)`;
				}
			});
		});
	}

	disconnect() {
		if (this.lenis) {
			this.lenis.destroy();
			this.lenis = null;
		}
	}
}
